import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AppErrorBoundary } from "./app/errors/AppErrorBoundary";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element is unavailable.");

createRoot(root).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>
);
